export default __webpack_public_path__ + "static/media/hot-air-balloon.a37055e8.png";